import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { filter, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenBootstrapService {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService
  ) { }

  initializeTokenBootstrap(): void {
    const deepestRoute = this.getDeepestChild(this.activatedRoute);
    const params = deepestRoute.snapshot.queryParams;
    const tokenInUrl = params['token'];

    //console.log('[TokenBootstrap] - activatedRoute:', this.activatedRoute);
    //console.log('[TokenBootstrap] - deepestRoute:', deepestRoute);

    //console.log('[TokenBootstrap] - URL:', this.router.url);
    //console.log('[TokenBootstrap] Query Params:', params);

    if (tokenInUrl) {
      //console.log('[TokenBootstrap] (immediate check) - token:', tokenInUrl);
      this.authService.setToken(tokenInUrl);
    }

    // Also run this after NavigationEnd in case the user navigates
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      take(1)
    ).subscribe(() => {


      //console.log('[TokenBootstrap] - NavigationEnd');

      const postNavRoute = this.getDeepestChild(this.activatedRoute);
      const postNavParams = postNavRoute.snapshot.queryParams;
      const token = postNavParams['token'];

      if (token) {
        //console.log('[TokenBootstrap - NavigationEnd] token:', token);
        this.authService.setToken(token);
        // Remove token from URL but preserve other query params
        const cleanedQueryParams = { ...postNavParams };
        delete cleanedQueryParams['token'];
        
        this.router.navigate([], {
          queryParams: cleanedQueryParams,
          replaceUrl: true
        });
      }
    });
  }

  private getDeepestChild(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }
}
